import { Observable, EMPTY as EMPTY_OBSERVABLE } from 'rxjs'
import processSuggestionData from '@aytm/app/stats/lib/render/draft-js/autocompletePlugin/lib/process-suggestion-data'

const valueTokenType = 'STR'
const lastTypes = ['EQ', 'NEQ']
const prelastTypes = ['TRAIT']
const ignoredTokens = ['AGE', 'PANEL', 'STATUS', 'GROUP']

export default function createTraitSuggestion(
  _,
  __,
  {
    dependencies: {
      aytmLogic: { refsList, traits },
      parserResult
    }
  }
) {
  if (!traits || !parserResult || !refsList) {
    return EMPTY_OBSERVABLE
  }

  const {
    tokens: { expected, match, type },
    text: { nonParsed }
  } = parserResult

  const canCreateSuggestion =
    lastTypes.includes(type.last) && prelastTypes.includes(type.prelast) && expected.last.includes(valueTokenType)

  if (!canCreateSuggestion) {
    return EMPTY_OBSERVABLE
  }

  const variable = match.prelast
  const hasCurrentVariable =
    't' === refsList[variable] && !ignoredTokens.includes(variable) && traits.some(t => variable.toLowerCase() == t.id)

  if (!hasCurrentVariable) {
    return EMPTY_OBSERVABLE
  }

  const transformToSuggestion =
    ({ canBeCompleted, parserResult }) =>
    value => {
      const token = valueTokenType
      const label = `"${value.id}"`
      const description = value.id !== (value.name.en || value.name) ? value.name.en || value.name : null

      return processSuggestionData('value', { canBeCompleted, token, label, parserResult, description })
    }

  return new Observable(observer => {
    const canBeCompleted = Boolean(nonParsed)
    const trait = traits.find(t => variable.toLowerCase() == t.id)
    const values = (trait.values || []).map(v => v)

    values
      .map(transformToSuggestion({ canBeCompleted, parserResult }))
      .filter(suggestion => suggestion)
      .forEach(suggestion => observer.next(suggestion))

    observer.complete()
  })
}
